import { toast } from "react-toastify";

import { getSubscriptionInovice } from "../../../../services";
import { numberWithCommas } from "../../../../utils";
import { SubscriptionTypeModalBodyContainer } from "../../styled";
import { Button } from "../../../Button";
import configs from "../../../../configs";

export const SubscriptionTypeBody = ({ subscription, closeModal }) => {
  async function handleYesOnClick() {
    const redirectUrl = configs.PAYMENT_RESULT_URL;
    const productId = subscription.entityId;
    try {
      const response = await getSubscriptionInovice(productId, redirectUrl);
      if (response.data.type === "DIRECT") {
        toast("با موفقیت پرداخت شد", { type: "success", toastId: "success" });
        closeModal();
      } else {
        window.location.href = response.data.url;
      }
    } catch (error) {
      toast("مشکلی پیش آمده است", { type: "error", toastId: "error" });
    }
  }
  return (
    <SubscriptionTypeModalBodyContainer>
      <h1>
        آیا مایل به پرداخت مبلغ{" "}
        <span>{numberWithCommas(subscription.price)}</span> برای فعال سازی{" "}
        <span>{subscription.name}</span> هستید؟
      </h1>
      <div className="buttons-container">
        <Button onClick={closeModal} color="red">
          لغو پرداخت
        </Button>
        <Button onClick={handleYesOnClick} color="green">
          بله پرداخت شود
        </Button>
      </div>
    </SubscriptionTypeModalBodyContainer>
  );
};
